export default {
  formId: 'sendForm',
  formField: {
    amount: {
      name: 'amount',
      requiredErrorMsg: ''
    },
    receiverId: {
      name: 'receiverId',
      placeholder: 'Account ID',
      requiredErrorMsg: ''
    },
    token: {
      name: 'token',
      requiredErrorMsg: ''
    }
  }
};
